import {Component} from '@angular/core';
import {Button, ButtonDirective} from "primeng/button";
import {TranslatePipe} from "@ngx-translate/core";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {FormBuilder} from "@components/form-builder/form-builder";

@Component({
  selector: 'app-modal-form-edit',
  imports: [
    ButtonDirective,
    TranslatePipe,
    Button,
    FormBuilder,
  ],
  templateUrl: './modal-form-edit-all.component.html',
  styleUrl: './modal-form-edit-all.component.scss',
  standalone: true
})
export class ModalFormEditAllComponent {
  model: any;
  isLoading = false;


  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    this.model = this.config.data?.model || {};
  }

  save(): void {

    this.isLoading = true;

    const service = this.config.data?.service as any;
    const createMethod = this.config.data?.createMethod as any;
    let finalMethod = this.config.data?.saveMethod as any;
    const fieldId = this.config.data?.fieldId as string;

    // Add fieldId to model if provided
    const payload = {
      ...this.model,
      ...(fieldId && { fieldId: fieldId })
    };

    if (!this.model.id && createMethod) {
      finalMethod = createMethod;
    }

    service[finalMethod](payload)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.ref.close({
            success: true,
            data: response || payload
          });
        },
        error: (error: any) => {
          console.error('Update Error:', error);
          this.isLoading = false;
        }
      });
  }

  cancel(): void {
    // Close the dialog without returning data
    this.ref.close();
  }
}
